import { canUseDOM } from '@/app/common/utils/canUseDOM';
import type { CommonData } from '@/app/common/createCommonData.ts';
import { MEASUREMENT_CONSENT_COOKIE_NAME, hasMeasurementConsentInCookieValue } from './measurementConsentCookie.ts';

// Has the user accepted the cookie category "Measurement"?
// Check for the 'oil_GTM_cookie' cookie, ensuring that its value contains the value `"5":true`.
export const consentCategoryMeasurementGiven = (commonData?: Pick<CommonData, 'isLocal'>) => {
  if (!canUseDOM) return false;
  if (commonData?.isLocal) return true;

  const cookieValue = document.cookie
    .split('; ')
    .find((row) => row.startsWith(`${MEASUREMENT_CONSENT_COOKIE_NAME}=`))
    ?.split('=')[1];

  return hasMeasurementConsentInCookieValue(cookieValue);
};
